import { css } from '@emotion/react';
import { useSelector } from 'react-redux';

import { ComponentType, LectureComponent } from 'redux/schemas/models/lecture-component';
import { AiSuggestedComponentProps } from 'redux/schemas/models/ai-course-creation';
import { Exercise } from 'redux/schemas/models/exercise';
import { getNovoAIProperties } from 'redux/selectors/lecture-page';
import { NovoAIItemType } from 'redux/schemas/models/lecture-page';

import { standardSpacing } from 'styles/global_defaults/scaffolding';
import QuizQuestions from './quiz-questions';
import PollQuestion from './poll-question';
import SurveyQuestion from './survey-question';
import ActivityDescription from '../activity-description';

const styles = css`
  p, ul {
    margin-bottom: 0px;
  }
`;

const exerciseStyles = css`
  p {
    margin-bottom: ${standardSpacing}px;
  }

  /* Remove margin-bottom from the last element to avoid extra space,
   * since the modal already has bottom spacing */
  p:last-child {
    margin-bottom: 0;
  }
`;

const ActivityInfo = ({ componentSet }: AiSuggestedComponentProps) => {
  const novoAI = useSelector(getNovoAIProperties);

  switch (componentSet.activity.type) {
    case ComponentType.PROFILE_COMPLETION:
    case ComponentType.MEET_AND_GREET:
      return componentSet.activity.content ? (
        <div
          css={styles}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: componentSet.activity.content }}
        />
      ) : null;
    case ComponentType.RICH_TEXT:
    case ComponentType.TEXT_WITH_IMAGE_TOP:
    case ComponentType.TEXT_WITH_IMAGE_BKG:
    case ComponentType.TEXT_WITH_IMAGE_SIDE:
      return (
        <div
          className='text-large-body'
          css={styles}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: componentSet.activity.content }}
        />
      );
    case ComponentType.TOPIC:
      return (
        <div
          css={styles}
          className='mt-4'
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: (componentSet.activity as LectureComponent<ComponentType.TOPIC>).topic.body }}
        />
      );
    case ComponentType.EXERCISE:
      return (
        <div
          css={exerciseStyles}
          className='mt-4'
          // here the type is TimelineExercise, We are not normalizing the components
          // for suggest activities. so Cast the exercise to the correct type
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: (componentSet.activity.exercise as unknown as Exercise).description }}
        />
      );
    case ComponentType.PUBLIC_PEER_EVALUATION:
      return <ActivityDescription description={componentSet.activity.peerEvaluation.description} />;
    case ComponentType.QUIZ:
      return <QuizQuestions componentSet={componentSet} />;
    case ComponentType.POLL:
      return <PollQuestion componentSet={componentSet} />;
    case ComponentType.SURVEY:
      return (
        <SurveyQuestion
          componentSet={componentSet}
          showFullQuestions={novoAI.itemType !== NovoAIItemType.SUGGEST_ACTIVITIES}
        />
      );
    default:
      return null;
  }
};

export default ActivityInfo;
